<template>
    <div id="showCard">
        <div class="d-flex justify-content-center mt-5">
            <b-button variant="outline-primary" class="mr-2" @click="printCard(staffId,'front')">{{ $t("download_front") }}</b-button>
            <b-button variant="outline-primary" @click="printCard(staffId,'back')"> {{ $t("download_back") }}</b-button>
        </div>
        <div class="d-flex justify-content-center mt-5">
            <b-button variant="outline-primary" class="mr-2" @click="printCard(staffId,'duplex')">{{ $t("download_front_and_back") }}</b-button>
        </div>
    </div>
</template>
<script>
    import IdentityCardService from "@/services/IdentityCardService";
    import {EventBus} from "@/main";
    import toBase64 from "@/helpers/toBase64";

    export default {
        props:{
          staffId:{
              type:Number
          }
        },
        data() {
            return {
                asPrint: null,
                cardPhotoF: null,
                cardPhotoB: null,
                cardPhotoP: null,
            }
        },
        methods:{
            async printCard(id,side) {
                try {
                    if (!side) return
                    const config = {
                        params:{
                            print_type:side
                        }
                    }
                    const data = await IdentityCardService.printCard(id, config);
                    if (side==='duplex'){
                        const fileName=this.$t('identity_card')+'.pdf'
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: data.data, pdfFileName: fileName});
                    }else {
                        let b64=toBase64(data);
                        const winHtml = '<html><body style="margin:0"><img src="'+b64+'" width="500"></body></html>';

                        const winUrl = URL.createObjectURL(
                            new Blob([winHtml], { type: "text/html" })
                        );

                        let x = screen.width / 2;
                        const win = window.open(
                            winUrl,
                            "Print",
                            "width=800,height=800,screenX="+x
                        );
                        win.print();
                    }

                } catch (err) {
                    this.showErrors(err,null,true);
                }
            },
        }
    }

</script>
